var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-center text-break",class:{
      'justify-start': _vm.justifyLeft,
      'justify-end': _vm.justifyRight,
      'justify-center': !_vm.justifyLeft && !_vm.justifyRight,
      pointer: _vm.clickable,
    },on:{"click":function($event){$event.stopPropagation();_vm.clickable ? _vm.$helpers.goToService(_vm.service, _vm.pushTransition) : null}}},[(_vm.avatar)?_c('v-avatar',{staticClass:"mr-2 align-self-start",attrs:{"left":"","size":_vm.dense ? 32 : 42}},[_c('v-img',{attrs:{"src":_vm.avatar}})],1):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }